var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stdin_exports = {};
__export(stdin_exports, {
  fromJSONSchema: () => fromJSONSchema,
  toJSONSchema: () => toJSONSchema
});
module.exports = __toCommonJS(stdin_exports);
var import_tslib = require("tslib");
var import_pick = __toESM(require("lodash/pick"));
var import_eval = require("../utils/eval");
var import_isNil = __toESM(require("lodash/isNil"));
const commonValidationKeys = [
  "multipleOf",
  "maximum",
  "exclusiveMaximum",
  "minimum",
  "exclusiveMinimum",
  "maxLength",
  "minLength",
  "pattern",
  "maxItems",
  "minItems"
];
const commonRootKeys = [
  "title",
  "description",
  "default",
  "$ref"
];
const unsupportedObjectKeys = ["propertyNames", "minProperties", "maxProperties", "dependencies"];
const unsupportedRootKeys = ["$id", "oneOf", "anyOf", "not", "allOf"];
function fromJSONSchema(input, opts = {}) {
  var _a, _b, _c, _d, _e, _f;
  const output = Object.assign({ type: input.type }, (0, import_pick.default)(input, commonRootKeys));
  const childOpts = Object.assign(Object.assign({}, opts), { root: opts.root || output });
  const handledJsonSchemaKeys = /* @__PURE__ */ new Set();
  if (input.definitions) {
    output.definitions = Object.keys(input.definitions).map((id) => {
      const el = fromJSONSchema(input.definitions[id]);
      return Object.assign(Object.assign({}, el), { id });
    });
  }
  if (input.$ref) {
    let refTo;
    if (input.$ref === "#")
      refTo = opts.root;
    else {
      const refId = (_a = /^#\/definitions\/(.+)$/.exec(input.$ref)) === null || _a === void 0 ? void 0 : _a[1];
      refTo = (_c = (_b = opts.root) === null || _b === void 0 ? void 0 : _b.definitions) === null || _c === void 0 ? void 0 : _c.find((x) => x.id === refId);
    }
    if (!refTo)
      throw new Error(`Invalid $ref: ${input.$ref}`);
    output.type = output.type || refTo.type;
  }
  if (Array.isArray(input.enum)) {
    output.type = output.type || typeof input.enum[0];
    output.enum = input.enum.map((value) => ({ value }));
    (_e = (_d = input.options) === null || _d === void 0 ? void 0 : _d.enum_titles) === null || _e === void 0 ? void 0 : _e.slice(0, output.enum.length).forEach((title, index) => {
      output.enum[index].label = title;
    });
  } else if (Array.isArray(input.oneOf) && !(0, import_isNil.default)((_f = input.oneOf[0]) === null || _f === void 0 ? void 0 : _f.const)) {
    output.type = output.type || typeof input.oneOf[0].const;
    output.enum = input.oneOf.map((x) => {
      const item = { value: x.const };
      if (x.description)
        item.label = x.description;
      return item;
    });
    handledJsonSchemaKeys.add("oneOf");
  }
  if (!output.type) {
    throw new Error("type is required");
  }
  unsupportedRootKeys.forEach((key) => {
    if (handledJsonSchemaKeys.has(key))
      return;
    if (key in input)
      throw new Error(`Schema.${key} is not supported`);
  });
  if (input.examples)
    output.examples = input.examples.map((value) => ({ value }));
  switch (input.type) {
    case "object": {
      const requiredList = input.required;
      if (input.properties) {
        output.fields = Object.keys(input.properties).map((id) => {
          const out = Object.assign(Object.assign({}, fromJSONSchema(input.properties[id], childOpts)), { id });
          if (requiredList === null || requiredList === void 0 ? void 0 : requiredList.some((x) => x === id))
            out.required = true;
          return out;
        });
      }
      if (input.additionalProperties) {
        if (input.additionalProperties === true)
          output.additionalFields = { type: "any" };
        else {
          output.additionalFields = fromJSONSchema(input.additionalProperties, childOpts);
        }
      }
      unsupportedObjectKeys.forEach((key) => {
        if (input[key])
          throw new Error(`Object.${key} is not supported`);
      });
      break;
    }
    case "array": {
      if (input.items) {
        output.items = fromJSONSchema(input.items, childOpts);
      }
      break;
    }
  }
  const validation = (0, import_pick.default)(input, commonValidationKeys);
  if (Object.keys(validation).length)
    output.validation = validation;
  return output;
}
function toJSONSchema(input) {
  const output = (0, import_pick.default)(input, commonRootKeys);
  if (input.type && input.type !== "any")
    output.type = input.type;
  if ((0, import_eval.isExprObject)(output.default))
    throw new Error("$expr is not supported by JSON Schema");
  if (input.examples)
    output.examples = input.examples.map(({ value }) => value);
  if (input.enum)
    output.enum = input.enum.map(({ value }) => value);
  switch (input.type) {
    case "object":
      if (input.fields) {
        const requiredList = [];
        const properties = {};
        input.fields.forEach((_a) => {
          var { id, required } = _a, rest = (0, import_tslib.__rest)(_a, ["id", "required"]);
          if (!id)
            return;
          properties[id] = toJSONSchema(rest);
          if (required)
            requiredList.push(id);
        });
        output.properties = properties;
        if (requiredList.length)
          output.required = requiredList;
        if (input.additionalFields)
          output.additionalProperties = toJSONSchema(input.additionalFields);
      }
      break;
    case "array":
      if (input.items) {
        output.items = toJSONSchema(input.items);
      }
      break;
  }
  if (input.validation) {
    Object.assign(output, (0, import_pick.default)(input.validation, commonValidationKeys));
  }
  if (input.definitions) {
    output.definitions = {};
    input.definitions.forEach((_a) => {
      var { id } = _a, rest = (0, import_tslib.__rest)(_a, ["id"]);
      if (!id)
        return;
      output.definitions[id] = toJSONSchema(rest);
    });
  }
  return output;
}
